import styled from '@emotion/styled';
import { Backdrop } from '@material-ui/core';

const StyledBackdrop = styled(Backdrop)`
  color: #fff;
  z-index: 10500;
`;

export default StyledBackdrop;
